import React, { useContext } from "react";
import SetdataProvider from "../context/SetdataContext";
import FormData from "./FormData";

function SetData() {

    return(
            <div className="setData">
                <FormData />
            </div>
    )
}

export default SetData